import React, { useEffect, useState } from "react";
import { FilterType } from ".";
import { ForwardIcon, TickIcon } from "../../assets/svg";
import CollegeDropDown from "../../components/college-dropDown";
import YearPicker from "../../components/date-picker/year";
import { DepartmentDropDown } from "../../components/department-dropDown";
import { useAppSelector } from "../../modal/hooks";
import "./filter.scss";

const currentYear = new Date().getFullYear().toString();
interface FilterProps {
	isFilterOpen: boolean;
	handleFilterOpen: () => void;
	// handleApplyFilter: () => void;
	handleClearAll: () => void;
	handleFilterChange: (key: keyof FilterType, value: any) => void;
	filterData: FilterType;
}

export const FilterComponent: React.FunctionComponent<FilterProps> = ({
	isFilterOpen,
	handleFilterOpen,
	handleFilterChange,
	filterData,
	// handleApplyFilter,
	handleClearAll,
}) => {
	const colleges = useAppSelector((store) => store.college.colleges);
	const typeAndWeighatage = useAppSelector((store) => store.settings.queTypeAndWeightage);
	interface Option {
		value: number;
		label: string;
	}

	useEffect(() => {
		const newOptions = colleges.map((e): Option => ({ value: e.id, label: e.name }));
		setCollegeOptions(newOptions);
	}, [colleges]);

	const [collegeOptions, setCollegeOptions] = useState<Option[]>([]);

	return (
		<div className={`filter_main_container ${isFilterOpen ? "open" : ""} d-flex flex-column`}>
			<div className="filter_container d-flex flex-column overflow-auto">
				<div className="filter_main_container_header d-flex align-items-center justify-content-between">
					<div>
						<span className="forward_icon" onClick={handleFilterOpen} style={{ cursor: "pointer" }}>
							<ForwardIcon width={15} height={16} color="none" className="mb-1" />
						</span>
						<span className="head">Filters</span>
					</div>
					<div
						className="status_filter_container warehouse_status_filter min_width_150 d-flex align-items-center cursor_pointer ml-1 pr-3 justify-content-center"
						onClick={handleClearAll}
					>
						<span className="px-1 cursor_pointer theme_color font_weight_medium font_15 pt-1" onClick={handleClearAll}>
							Clear filter
						</span>
					</div>
				</div>
				<div className="divider"></div>
				<div className="sub_head">Question type</div>
				<div className="question_types">
					{typeAndWeighatage.map((item: any, index) => {
						return (
							<span
								key={index}
								className={`chip ${filterData.questionType.includes(item) ? "que_type_selected" : ""}`}
								onClick={() => {
									handleFilterChange("questionType", item);
								}}
							>
								{filterData.questionType.includes(item) && <TickIcon width={12} height={15} color="none" />}
								{item.name}
							</span>
						);
					})}
				</div>
				<div className="sub_head">Exam status</div>
				<div className="question_types">
					<span
						style={{ width: "130px" }}
						className={`chip ${filterData.examStatus === "SELECTED" ? "exam_status_selected" : ""}`}
						onClick={() => {
							handleFilterChange("examStatus", "SELECTED");
						}}
					>
						{filterData.examStatus === "SELECTED" && <TickIcon width={12} height={15} color="none" />}
						Selected
					</span>
					<span
						style={{ width: "130px" }}
						className={`chip ${filterData.examStatus === "NOT-SELECTED" ? "exam_status_selected" : ""}`}
						onClick={() => {
							handleFilterChange("examStatus", "NOT-SELECTED");
						}}
					>
						{filterData.examStatus === "NOT-SELECTED" && <TickIcon width={12} height={15} color="none" />}
						Not selected
					</span>
				</div>
				<div className="sub_head">Answer status</div>
				<div className="question_types">
					<span
						style={{ width: "140px" }}
						className={`chip ${filterData.answerStatus === true ? "answer_status_selected" : ""}`}
						onClick={() => {
							handleFilterChange("answerStatus", true);
						}}
					>
						{filterData.answerStatus === true && <TickIcon width={12} height={15} color="none" />}
						Completed
					</span>
					<span
						style={{ width: "140px" }}
						className={`chip ${filterData.answerStatus === false ? "answer_status_selected" : ""}`}
						onClick={() => {
							handleFilterChange("answerStatus", false);
						}}
					>
						{filterData.answerStatus === false && <TickIcon width={12} height={15} color="none" />}
						Not completed
					</span>
				</div>
				<div className="d-flex gap-2">
					<div className="sub_head">
						<span style={{ marginBottom: "4px" }}>Score threshold</span>
						<div className="custom_main_form">
							<div className="custom_input_field_container position-relative">
								<input
									className="custom_input_field"
									type="text"
									placeholder="Enter score"
									// disabled={props.disabled}
									inputMode="text"
									value={filterData.thresHold}
									onChange={(e) => {
										handleFilterChange("thresHold", e.target.value);
									}}
								/>
								{/* {invalid.name ? <span className="invalid_message invalid_top_minus_16">Enter your name</span> : ""} */}
							</div>
						</div>
					</div>
					<div className="sub_head">
						<span style={{ marginBottom: "4px" }} className="pl-2">
							Year
						</span>
						<div className="custom_input_field_container max_width_210 flex_1_1_10 ml-2">
							<YearPicker
								// handleChange={(e: string) => {
								// 	setFilter({ ...filter, year: e || currentYear });
								// }}
								handleChange={(e: string) => {
									handleFilterChange("year", e || currentYear);
								}}
								value={filterData.year}
							/>
						</div>
					</div>
				</div>
				<div className="d-flex gap-2">
					<div className="sub_head">
						<span style={{ marginBottom: "4px" }}>Backlog</span>
						<div className="custom_main_form">
							<div className="custom_input_field_container position-relative">
								<input
									className="custom_input_field"
									type="text"
									placeholder="Enter backlog"
									// disabled={props.disabled}
									inputMode="text"
									value={filterData.backlog}
									onChange={(e) => {
										handleFilterChange("backlog", e.target.value);
									}}
								/>
								{/* {invalid.name ? <span className="invalid_message invalid_top_minus_16">Enter your name</span> : ""} */}
							</div>
						</div>
					</div>
					<div className="sub_head">
						<span style={{ marginBottom: "4px" }} className="pl-2">
							Cgpa
						</span>
						<div className="custom_main_form">
							<div className="custom_input_field_container max_width_210 flex_1_1_10 ml-2">
								<input
									className="custom_input_field"
									type="text"
									placeholder="Enter cgpa"
									// disabled={props.disabled}
									inputMode="text"
									value={filterData.cgpa}
									onChange={(e) => {
										handleFilterChange("cgpa", e.target.value);
									}}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="pr-1">
					<div style={{ marginBottom: "4px" }} className="sub_head">
						College
					</div>
					<div className="custom_main_form">
						<CollegeDropDown
							clearable
							// handleChange={(e: number | null) => {
							// 	setFilter({ ...filter, college: e });
							// }}
							handleChange={(e: number | null) => {
								handleFilterChange("college", e);
							}}
							value={filterData.college}
						/>
					</div>
					<div style={{ marginBottom: "4px" }} className="sub_head">
						Department
					</div>
					<div className="custom_main_form">
						<DepartmentDropDown
							clearable
							// handleChange={(e: string) => {
							// 	setFilter({ ...filter, department: e });
							// }}
							handleChange={(e: string | null) => {
								handleFilterChange("department", e);
							}}
							value={filterData.department}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
